/**
 * Task creator or any assigned user may mark a task complete (status → done).
 * @param {string|undefined|null} userId - current user id
 * @param {object|undefined} task - task with populated or raw assignment fields
 */
export function canMarkTaskComplete(userId, task) {
  if (userId == null || !task) return false;
  const uid = String(userId);
  const creatorId =
    typeof task.createdBy === "object" ? task.createdBy?._id : task.createdBy;
  if (creatorId != null && String(creatorId) === uid) return true;

  const fromAssignedUsers = Array.isArray(task.assignedUsers)
    ? task.assignedUsers
        .map((u) => (typeof u === "object" ? u?._id : u))
        .filter(Boolean)
    : [];
  const primaryAssignee =
    typeof task.assignedTo === "object" ? task.assignedTo?._id : task.assignedTo;
  const assigneeIds = [...new Set([...fromAssignedUsers, primaryAssignee].filter(Boolean).map(String))];
  return assigneeIds.includes(uid);
}
